module.exports = __webpack_public_path__ + "static/company-registration-6bedd5f07b7073d1db2a96d0105c3874.svg";